import styled from 'styled-components';

/* Youtube videos cannot dynamically change their height based on their width, but we need
this to be the width of the container. Hence we use this slightly strange pattern of a
0-height container with the padding required for a 16:9 video, and an absolutely-positioned
iframe with the video itself. */
export const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
`;

export const VideoFrame = styled.iframe`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border: none;
`;
